import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { incadeaConfig, incadeaEnvironment } from "src/environments/environment";
import { ResponseAppointment } from "../incadea-interfaces/responses/ResponseAppointment.interface";
import { AppointmentCreate } from "../incadea-interfaces/requests/RequestAppointmentCreate.interface";
@Injectable({
    providedIn: 'root',
  })
export class GetAppointmentCreate {

    constructor(private http: HttpClient) { }

    public postAppointmnet(token:string,CompanyId:string,appointmentData:AppointmentCreate ,backEndCode:string) {
        // Define el encabezado de la solicitud
        const headers = new HttpHeaders()
        .set('Accept-Language', 'en-US,en;q=0.9')
        .set('Authorization', `Bearer ${token}`) 
        .set('backend-code', `${backEndCode}`);

        const url = new URL(`${incadeaEnvironment.departments}/${CompanyId}/appointments`)
        
        
        // Realiza la solicitud POST
       return this.http.post<ResponseAppointment>(url.toString(),appointmentData, { headers })
      }

      public cancelAppointmnet(token:string,CompanyId:string,appointmentId,backEndCode:string ) {
        // Define el encabezado de la solicitud
        const headers = new HttpHeaders()
        .set('Accept-Language', 'en-US,en;q=0.9')
        .set('Authorization', `Bearer ${token}`)
        .set('backend-code', `${backEndCode}`);
        const url = new URL(`${incadeaEnvironment.departments}/${CompanyId}/appointments/${appointmentId}/cancel`)
        // Realiza la solicitud POST
        return this.http.post<any>(url.toString(), {}, { headers,observe:'response' });
      }
    }
  